import {
  ADD_RESPONSIBLE_PARTIES_REQUEST,
  ADD_RESPONSIBLE_PARTIES_SUCCESS,
  ADD_RESPONSIBLE_PARTIES_ERROR,
  EDIT_RESPONSIBLE_PARTIES_REQUEST,
  EDIT_RESPONSIBLE_PARTIES_SUCCESS,
  EDIT_RESPONSIBLE_PARTIES_ERROR,
  RESET_STATE_REDUX,
  RESET_STATE_ALL_APPLICATION,
  DELETE_RESPONSIBLE_PARTIES_REQUEST,
  DELETE_RESPONSIBLE_PARTIES_SUCCESS,
  DELETE_RESPONSIBLE_PARTIES_ERROR,
  LIST_RESPONSIBLE_PARTIES_REQUEST,
  LIST_RESPONSIBLE_PARTIES_SUCCESS,
  LIST_RESPONSIBLE_PARTIES_ERROR,
} from '../../actions';

const INIT_STATE = {
  currentResponsibleParties: null,
  currentResponsiblePartiesList: null,
  loading: false,
  error: '',
  success: '',
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case RESET_STATE_ALL_APPLICATION:
      return INIT_STATE;
    case RESET_STATE_REDUX:
      return {
        ...state,
        error: '',
        currentResponsibleParties: null,
        success: '',
      };
    case LIST_RESPONSIBLE_PARTIES_REQUEST:
      return { ...state, loading: true, error: '' };
    case LIST_RESPONSIBLE_PARTIES_SUCCESS:
      return {
        ...state,
        loading: false,
        currentResponsiblePartiesList: action.payload,
        error: '',
      };
    case LIST_RESPONSIBLE_PARTIES_ERROR:
      return {
        ...state,
        loading: false,
        currentResponsiblePartiesList: null,
        error: action.payload.message,
      };
    case ADD_RESPONSIBLE_PARTIES_REQUEST:
      return { ...state, loading: true, error: '', success: '' };
    case ADD_RESPONSIBLE_PARTIES_SUCCESS: {
      const allResponsibleParties = [...state.currentResponsiblePartiesList, action.payload];
      return {
        ...state,
        currentResponsiblePartiesList: allResponsibleParties,
        loading: false,
        success: action.payload,
        error: '',
      };
    }
    case ADD_RESPONSIBLE_PARTIES_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
        success: '',
      };
    case EDIT_RESPONSIBLE_PARTIES_REQUEST:
      return { ...state, loading: true, error: '', success: '' };
    case EDIT_RESPONSIBLE_PARTIES_SUCCESS: {
      const responsiblePartiesUpdated = state.currentResponsiblePartiesList.map((responsibleParties) => {
        if (responsibleParties.id === action.payload.responsibleParties.id) {
          return action.payload.responsibleParties;
        }
        return responsibleParties;
      });
      return {
        ...state,
        currentResponsiblePartiesList: responsiblePartiesUpdated,
        edited: true,
        loading: false,
        success: action.payload,
        error: '',
      };
    }
    case EDIT_RESPONSIBLE_PARTIES_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
        success: '',
      };
    case DELETE_RESPONSIBLE_PARTIES_REQUEST:
      return { ...state, error: '' };
    case DELETE_RESPONSIBLE_PARTIES_SUCCESS:
      const responsiblePartiesUpdated = state.currentResponsiblePartiesList.filter((responsibleParties) => {
        return responsibleParties.id !== action.payload.id;
      });

      return {
        ...state,
        currentResponsiblePartiesList: responsiblePartiesUpdated,
        error: '',
      };
    case DELETE_RESPONSIBLE_PARTIES_ERROR:
      return {
        ...state,
        error: action.payload.message,
      };
    default:
      return { ...state };
  }
};
